import { hasWhiteSpace } from "@utils";
import {
  INSTAGRAM_REGEX, TWITTER_REGEX,
} from '@utils/regexes'

const yup = require("yup");

const validations = {
  twitterUsername: yup
    .string()
    .required("Please enter your Twitter username.")
    .test(
      "twitterUsername",
      "No need to use your full twitter URL. We only need your Twitter username.",
      val => {
        return !TWITTER_REGEX.test(val);
      }
    ).test('twitterUsername', 'Twitter username must not have space', function validate(twitterUsername) {
      return !hasWhiteSpace(twitterUsername);
    }),
  instagramUsername: yup
    .string()
    .required("Please enter your public Instagram username.")
    .test(
      "instagramUsername",
      "No need to use your full Instagram URL. We only need your Instagram username.",
      val => {
        return !INSTAGRAM_REGEX.test(val);
      }
    ).test('instagramUsername', 'Instagram username must not have space', function validate(instagramUsername) {
      return !hasWhiteSpace(instagramUsername)
    }),
    email: yup.string().required("Email is required"),
    firstName: yup.string().required("Please enter your legal first name"),
    lastName: yup.string().required("Please enter your legal last name"),
    location: yup.string().required("Please enter your location"),
    username: yup.string().required("Please enter your username").test('username', 'Username must not have space', function validate(username) {
      return !hasWhiteSpace(username);
    }),
    phoneNumber: yup.string().required("Phone number is required"),
    goodFitInfo: yup.string().required("Please enter why you're a good fit").min(
      120, 'Please enter at least 120 characters'
    )
};

export default validations;
